import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

const Container = styled.div`
  & > .fa {
    font-size: 18px;
    padding: 0 1em;
    color: ${props => props.theme.secondaryColor};
  }

  &.enabled > .fa-refresh:hover, &.enabled > .fa-plus:hover {
    color: ${props => props.theme.primaryColor};
    cursor: pointer;
  }

  & > .fa-minus:hover {
    color: ${props => props.theme.primaryColor};
    cursor: pointer;
  }
`;
export default function Actions({
  enabled, creating, onRefresh, onCreate,
}) {
  return (
    <Container className={classNames({ enabled })}>
      <i role="region" className="fa fa-refresh" onClick={onRefresh} />
      <i role="region" className={classNames('fa', { 'fa-plus': !creating, 'fa-minus': creating })} onClick={onCreate} />
    </Container>
  );
}

Actions.propTypes = {
  enabled: PropTypes.bool.isRequired,
  creating: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};
